import './polyfills'
import React, { Fragment } from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import registerServiceWorker from './registerServiceWorker'
import store, { history } from './redux/store'
import './index.css'
import 'tr-components/App.css'
import App from './containers/App'

import { baseUrl, version } from './config/endpoints'
import axiosConfig from './config/axios'
import { Route } from 'react-router-dom'

import ClientIdParser from './containers/ClientIdParser'

//configure global axios
axiosConfig(store)

console.log('v' + version)

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Route
        path={`${baseUrl}/clients/:clientId/:module(fields|forms|positions)?/:submodule(all|categories|groups|)?`}
        render={({ match }) => (
          <Fragment>
            <ClientIdParser match={match}>
              <App />
            </ClientIdParser>
          </Fragment>
        )}
      />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js